import Vue from 'vue';
import Cosmos from './cosmos';

Vue.use(Cosmos);
new Vue({

});



// WEBPACK FOOTER //
// ./src/js/script.js